import { styled, Box, Typography } from '@mui/material';

export const BANNER_HEIGHT_SPACING = 8;

export const Banner = styled(Box)`
  width: 100%;
  height: ${({ theme }) => theme.spacing(BANNER_HEIGHT_SPACING)};
  min-height: ${({ theme }) => theme.spacing(BANNER_HEIGHT_SPACING)};
  z-index: ${({ theme }) => theme.zIndex.tooltip};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.palette.primary.dark},
    ${({ theme }) => theme.palette.primary.main}
  );
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const BannerText = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;

export const CatalogLink = styled('a')`
  margin-left: ${({ theme }) => theme.spacing(3)};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-size: 0.75rem;
  text-decoration: underline;
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }
`;
